function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { responseMapper } from "../../helpers/responseMapper";
import { instance } from "../instance";
const getChatResponseTemplate = {
  code: 'headerResponse.code',
  message: 'headerResponse.message',
  payload: {
    totalPages: 'payload.pages',
    messages: ['payload.messages', {
      id: '_id',
      type: 'type',
      date: 'createdAt',
      status: 'status',
      from: 'from',
      caption: 'caption',
      content: 'content',
      replyTo: 'replyTo'
    }]
  }
};
export const getChat = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (_ref) {
    let userId = _ref.userId,
        withUserId = _ref.withUserId,
        page = _ref.page,
        rowsPerPage = _ref.rowsPerPage;
    const response = yield instance.post('privatechat/getchat', {
      usersId: [userId, withUserId],
      page,
      rowsPerPage
    });

    const _responseMapper = responseMapper({
      template: getChatResponseTemplate,
      data: response.data
    }),
          code = _responseMapper.code,
          message = _responseMapper.message,
          _responseMapper$paylo = _responseMapper.payload,
          messages = _responseMapper$paylo.messages,
          totalPages = _responseMapper$paylo.totalPages;

    if (code !== 200 && code !== 204) throw new Error('Hubo un error al recuperar los mensajes');
    return {
      messages: messages.reverse(),
      totalPages
    };
  });

  return function getChat(_x) {
    return _ref2.apply(this, arguments);
  };
}();